import React, {memo} from 'react'
import type {Row} from '@tanstack/react-table'
import {formatCellValue} from './reportTableUtils'

type Props = {
  rows: Row<any>[]
  // Column changes must refresh cells even if the data array is unchanged.
  columns: any[]
  onRowPointerDown: (event: React.PointerEvent<HTMLTableRowElement>, row: Row<any>) => void
  onRowPointerMove: (event: React.PointerEvent<HTMLTableRowElement>, row: Row<any>) => void
  onRowPointerCancel: () => void
  onRowClick: (event: React.MouseEvent<HTMLTableRowElement>, row: Row<any>) => void
  onRowDoubleClick: () => void
  onRowKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>, row: Row<any>) => void
}

export const ReportTableBody = memo(function ReportTableBody({
  rows, onRowPointerDown, onRowPointerMove, onRowPointerCancel,
  onRowClick, onRowDoubleClick, onRowKeyDown,
}: Props) {
  return (
    <tbody className='divide-y divide-gray-200 bg-white'>
      {rows.map((row, visibleRowIndex) => (
        <tr
          key={row.id}
          tabIndex={0}
          aria-label={'Abrir detalhes do registro ' + (visibleRowIndex + 1)}
          onPointerDown={(event) => onRowPointerDown(event, row)}
          onPointerMove={(event) => onRowPointerMove(event, row)}
          onPointerCancel={onRowPointerCancel}
          onClick={(event) => onRowClick(event, row)}
          onDoubleClick={onRowDoubleClick}
          onKeyDown={(event) => onRowKeyDown(event, row)}
          className='cursor-pointer hover:bg-blue-50 focus:bg-blue-50 focus:outline-none'
        >
          {row.getVisibleCells().map((cell) => {
            const displayValue = formatCellValue(cell.getValue())
            const width = `var(--report-column-${cell.column.id}-width)`
            return (
              <td
                key={cell.id}
                style={{width, maxWidth: width}}
                className='overflow-hidden whitespace-nowrap px-4 py-4 text-sm text-gray-900'
              >
                <div className='truncate' title={displayValue}>{displayValue}</div>
              </td>
            )
          })}
        </tr>
      ))}
    </tbody>
  )
})
